import { Loader } from "./loader";
import { HtmlTemplates } from "./html-templates";
import ChunkReplacer from "./chunkreplacer";
import logger from "./logger";

export class LoginHelper {

	isUserLoggedIn = 0;

	triggersSelector;
	modalSelector;
	usernameFieldSelector;
	passwordFieldSelector;
	rememberMeCheckSelector;
	logoutSelector;
	loaderSelector;
	loginResponseSelector;
	colorStyles = { bad: 'red', success: 'green', default: 'blue', hide: 'white' };
	reloadPages = [];
	pagename;

	/* for homeapge login*/
	passVisibilityIcons;
	inputFields;
	theForm;
	loginContainer;

	preparingTimeout = 1000;
	rememberMeDefaultValue = 1;

	getTriggers = () => {
		return document.querySelectorAll(this.triggersSelector)
	}
	getModal = () => {
		return document.getElementById(this.modalSelector)
	}
	getUsernameField = () => {
		return this.getModal().querySelector(this.usernameFieldSelector)
	}
	getPasswordField = () => {
		return this.getModal().querySelector(this.passwordFieldSelector)
	}
	getRememberCheck = () => {
		return this.getModal().querySelector(this.rememberMeCheckSelector)
	}

	setAuthStatus = async () => {
		this.isUserLoggedIn = this.checkIfLoggedIn();
		return this.isUserLoggedIn;
	}

	checkIfLoggedIn = () => {
		return document.querySelector(this.logoutSelector) ? 1 : 0;
	}


	toggleModal = async (e, goto) => {
		if (!this.getModal()) {
			if (e) e.preventDefault();
			let modal = await this.createModal();
			document.body.insertAdjacentHTML('beforeend', modal);
			this.passVisibilityIcons = document.querySelectorAll('label .password--visibility');
			this.controlPassVisibility();
			this.getModal().querySelector('#closeLoginModal').addEventListener('click', () => this.toggleModal());
			this.getModal().querySelectorAll('input').forEach((field) => {
				field.addEventListener('focusin', (e) => e.target.closest('label').classList.add('focus'));
				field.addEventListener('focusout', (e) => {
					if (e.target.value === "") e.target.closest('label').classList.remove('focus')
				});
				field.addEventListener('keyup', (e) => {
					if (e.target.value !== "") this.hideMsg()
				});
			});
			this.getModal().querySelector('form').addEventListener('submit', (e) => this.doFetch(e, goto));
			this.getUsernameField().focus();
		} else {
			this.getModal().remove();
		}
	}

	createModal = async () => {
		let m = await HtmlTemplates.getTemplate(HtmlTemplates.loginModal, true);
		let s = await HtmlTemplates.getTemplate(HtmlTemplates.loginSublinks, true);
		if (this.pagename.includes('fun-mode')) {
			s = await HtmlTemplates.getTemplate(HtmlTemplates.loginSublinksFunMode, true);
		}
		logger.log("Modal: " + m);
		return (new ChunkReplacer)
			.add('SUBLINKS', s)
			.replace(m)
	}


	showLoader = () => {
		if (this.getModal()) {
			const formContent = this.getModal().querySelector('.ContInfo');
			formContent.style.display = 'none';

			Loader.show(this.loaderSelector).then(r => {
				const loaderContent = this.getModal().querySelector('.BoxContPopup');
				const textElement = document.createElement('div');
				textElement.classList.add('text-box');

				textElement.innerHTML = `
				<p>Just a moment, nearly there!</p>
				<p>We’re verifying your details - please give us a moment.</p>
			`;
				loaderContent.appendChild(textElement);
			});
		} else {
			const formContent = document.querySelector('.hero--form.login');
			formContent.style.display = 'none';

			Loader.show('.hero--container.signup').then(() => {
				const loaderContent = document.querySelector('.hero--container.signup');
				const textElement = document.createElement('div');
				textElement.classList.add('text-box');

				textElement.innerHTML = `
				<p>Just a moment, nearly there!</p>
				<p>We’re verifying your details - please give us a moment.</p>
			`;
				loaderContent.appendChild(textElement);
			});
		}
	}

	hideLoader = () => {
		if (this.getModal()) {
			const content = this.getModal().querySelector('.ContInfo');
			if (content) {
				content.style.display = 'flex';
				if (this.getModal().querySelector('.text-box')) this.getModal().querySelector('.text-box').remove();
				Loader.hide(this.loaderSelector);
			}
		} else {
			const content = document.querySelector('.hero--form.login');
			if (content) {
				content.style.display = 'flex';
				const container = document.querySelector('.hero--container.signup');
				if (container.querySelector('.text-box')) container.querySelector('.text-box').remove();
				Loader.hide('.hero--container.signup');
			}
		}
	}

	showMsg = (type, msg = '') => {
		let msgElem = this.getModal().querySelector(this.loginResponseSelector);
		if (msgElem) {
			msgElem.innerHTML = msg;
			switch (type) {
				case 'bad':
					msgElem.style.color = this.colorStyles.bad;
					this.getUsernameField().closest('.box').classList.add('bad');
					this.getPasswordField().closest('.box').classList.add('bad');
					break;
				case 'success':
					msgElem.style.color = this.colorStyles.success;
					break;
				default:
					msgElem.style.color = this.colorStyles.default;
					break
			}
			msgElem.style.display = 'block';
		}
	}

	//
	hideMsg = () => {
		let msgElem = this.getModal().querySelector(this.loginResponseSelector);
		this.getUsernameField().classList.remove('bad');
		this.getPasswordField().classList.remove('bad');
		msgElem.style.display = 'none';
		msgElem.innerHTML = "";
		msgElem.style.color = this.colorStyles.hide;
	}

	requireAuthOn = (elements = null) => {
		if (elements === null || elements === undefined) return;
		elements.forEach((elem) => {
			elem.addEventListener('click', (e) => this.triggerControl(e, elem));
		})
	}

	/**
	 Control where the user is going to land after logging in.
	 The goto is the destination abs link which can be defined in 2 ways and is retrieved on every click
		1) the URL (?goto=/somelink) or
		2) by setting the data-goto attribute on the login button (element trigger - the ones with data-action="login" attribute)
	 */
	triggerControl = (e, btn) => {
		let goto = '';
		const currentURLParams = new URLSearchParams(window.location.search);
		if (currentURLParams.has('goto')) {
			goto = decodeURIComponent(currentURLParams.get('goto'));
		} else {
			if (btn) {
				goto = btn.dataset.goto !== undefined ? btn.dataset.goto : '';
			}
		}

		this.toggleModal(e, goto).then(r => {
		});

		return true;
	}

	doFetch = async (e, goto = '') => {
		e.preventDefault();

		this.hideMsg();

		let username = this.getUsernameField().value;
		let password = this.getPasswordField().value;
		let remember = this.getRememberCheck() ? (this.getRememberCheck().checked ? 1 : 0) : this.rememberMeDefaultValue;
		let usernameFake = this.getModal().querySelector('input[name="login"]').value;
		let passwordFake = this.getModal().querySelector('input[name="password"]').value;
		let token = $('#cftoken').val();

		if (username === "" || password === "") {
			this.showMsg('bad', 'Username and password required.');
			return;
		}

		const options = {
			method: 'post',
			headers: { 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' },
			body: `player_username=${username}&player_password=${password}&remember=${remember}&cf-turnstile-response=${token}`
		}

		if (usernameFake === "" && passwordFake === "") {
			// do submit
			this.showLoader();
			fetch(URL_API('login', 'user'), options)
				.then(response => response.json())
				.then(data => {
					if (data.error) {
						this.hideLoader();
						this.showMsg('bad', data.error);
					} else {
						this.showMsg('success', data.success);
						setTimeout(() => {
							if (goto === '' || goto === undefined) {
								const currentURLParams = new URLSearchParams(window.location.search);
								if (!currentURLParams.has('redeem') && data.redirect) {
									window.location.href = `${URL_PREFIX}${data.redirect}`;
								} else {
									if (currentURLParams.has('login')) { // URL with ?login
										currentURLParams.delete('login'); // remove ?login param so the modal doesn't appear again after loggging in
										// redirect custom
										if (data.redirect) {
											window.location.href = `${URL_PREFIX}${data.redirect}`;
										} else { // redirect to current page
											window.location = `${location.pathname}?${currentURLParams.toString()}`;
										}
									} else { // URL without ?login
										// redirect custom
										if (data.redirect) {
											window.location.href = `${URL_PREFIX}${data.redirect}`;
										} else {
											if (location.pathname && location.pathname !== '') {
												if (this.reloadPages.includes(this.pagename)) {
													location.reload();
												} else {
													window.location.href = URL_PREFIX;
												}
											}
										}
									}
								}
							} else {
								window.location.href = goto;
							}
						}, this.preparingTimeout);
					}
				})
				.catch(error => {
					this.hideLoader();
					this.showMsg('bad', 'Unknown error occurred.');
				});
		}
	}


	/** for homepage **/

	controlPassVisibility = () => {
		if (this.passVisibilityIcons) {
			this.passVisibilityIcons.forEach((icon) => {
				icon.addEventListener('click', (e) => {
					let passField = e.target.parentNode.querySelector(this.passwordFieldSelector);
					passField.type === 'password' ? passField.type = 'text' : passField.type = 'password';
					icon.classList.toggle('visible');
					return true;
				})
			})
		}
	}

	controlFocus = () => {
		if (this.inputFields) {
			this.inputFields.forEach((field) => {
				field.addEventListener('focus', (e) => {
					this.centerForm();
					let box = e.target.closest('.box');
					if (box) {
						box.classList.add('focus');
						return false;
					}
				});

				field.addEventListener('focusout', (e) => {
					if (e.target.value === "") e.target.closest('.box').classList.remove('focus')
				});
			})
		}
	}

	centerForm = () => {
		const isMobile = window.innerWidth <= 768;

		if (isMobile) {
			const element = document.querySelector(this.loginContainer);
			element.scrollIntoView();

			setTimeout(() => {
				window.scrollBy(0, -100);
			}, 0);
		}
	}

	doFetchHome = (e) => {
		e.preventDefault();
		// disable form inputs

		//let thisForm = e.target;
		// hide all messages if showing
		this.clearMessages();
		// check if bot
		logger.log(this.theForm);
		logger.log(this.usernameFieldSelector);
		logger.log(this.theForm.querySelector(this.usernameFieldSelector));

		const honeypot = this.theForm.querySelector('input[name="honeypot"]').value;
		if (honeypot !== '') { // prevent bot submits
			this.showMsgHome('bad', 'The system recognized you as a robot. If this is not the case, please contact support');
			return false;
		}
		// collect data
		const username = this.theForm.querySelector(this.usernameFieldSelector).value.replaceAll(' ', '');
		const password = this.theForm.querySelector(this.passwordFieldSelector).value.replaceAll(' ', '');
		let remember = this.getHomeRememberCheck() ? (this.getHomeRememberCheck().checked ? 1 : 0) : this.rememberMeDefaultValue;
		let token = $('#cftoken').val();

		if (username === "" || password === "") {
			this.showMsg('bad', 'Username and password required.');
			return;
		}

		const options = {
			method: 'post',
			headers: { 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' },
			body: `player_username=${username}&player_password=${password}&remember=${remember}&cf-turnstile-response=${token}`
		}

		// try login
		this.showLoader();
		fetch(URL_API('login', 'user'), options)
			.then(response => response.json())
			.then(data => {
				if (data.error) {
					this.showMsgHome('bad', data.error);
					this.hideLoader();
				} else { // success
					let goto = '';
					const currentURLParams = new URLSearchParams(window.location.search);
					if (currentURLParams.has('goto')) {
						goto = decodeURIComponent(currentURLParams.get('goto'));
					} else {
						if (data.redirect) goto = data.redirect;
					}
					this.showMsgHome('good', 'Success, redirecting...');
					logger.log('Success msg');
					setTimeout(() => {
						window.location.href = goto;
					}, this.preparingTimeout);
				}
			})
			.catch(error => {
				this.hideLoader();
				this.showMsgHome('bad', 'Unknown error occurred.');
			});
	}

	getHomeRememberCheck = () => {
		return this.theForm.querySelector(this.rememberMeCheckSelector)
	}

	clearMessages = () => {
		let messages = this.theForm.querySelectorAll('.msg');
		if (messages) messages.forEach((m) => m.remove()); // hides all
	}

	showMsgHome = (type, msg = '') => {
		let theBox = this.theForm.querySelector(this.usernameFieldSelector).closest('.box');
		let thePasswordBox = this.theForm.querySelector(this.passwordFieldSelector).closest('.box');

		this.theForm.querySelector('button').insertAdjacentHTML('afterend', `<div class="msg ${type} mt-15">${msg}</div>`);

		theBox.classList.remove(type === 'good' ? 'bad' : 'good');
		theBox.classList.add(type);
		thePasswordBox.classList.remove(type === 'good' ? 'bad' : 'good');
		thePasswordBox.classList.add(type);
	}

}